module.exports = __webpack_public_path__ + "fonts/WorkSans-Regular.2fe5c5a.eot";